import ContinueButton from '@/components/continue-button/continue-button';
import ContentContainerAuthPages from '@/components/layout-auth/components/content-container-auth-pages/content-container-auth-pages';
import FooterAuth from '@/components/layout-auth/components/footer-auth/footer-auth';
import FormContainerAuthPages from '@/components/layout-auth/components/form-container-auth-pages/form-container-auth-pages';
import ImageSectionAuthPages from '@/components/layout-auth/components/image-section-auth-pages/image-section-auth-pages';
import MainContentAuth from '@/components/layout-auth/components/main-content-auth/main-content-auth';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import LogOutButton from '@/components/log-out-button/log-out-button';
import TermsAndPrivacy from '@/components/terms-and-privacy/TermsAndPrivacy';
import Troubleshoot from '@/components/troubleshoot/Troubleshoot';
import { Box, Divider, Grid } from '@cmpsr/components';
import EarlyAccessForm from './components/early-access-form/early-access-form';
import EarlyAccessHeader from './components/early-access-header/early-access-header';
import useEarlyAccessController from './early-access.controller';

export default function EarlyAccessPage() {
  const { handleLogout, userEmail, form, handleSubmit } = useEarlyAccessController();

  return (
    <Box>
      <NavigationBar rightContent={<LogOutButton onClick={handleLogout} />} beta />
      <MainContentAuth>
        <ImageSectionAuthPages
          src="/images/early-access.jpg"
          alt="You have been added to our waitlist"
          display={{ base: 'none', lg: 'block' }}
          imageBoxProps={{ objectPosition: 'top left' }}
        />
        <ContentContainerAuthPages
          position={{ base: 'initial', lg: 'relative' }}
          background="url(/images/footer-auth_3840px.svg)"
          backgroundRepeat="no-repeat"
          backgroundPosition={{
            base: 'center calc(100% - 86px)',
            lg: 'center calc(100% - 56px)',
            xxl: 'center calc(100% - 86px)',
          }}
          backgroundSize="auto 200px"
        >
          <Grid
            // In short screen sizes the content will have scroll
            // In higher screen sizes the content will be centered and the footer will be at the bottom
            gridTemplateRows="minmax(min-content, 1fr) min-content"
            alignItems="center"
            minHeight="full"
            overflow="auto"
          >
            <Box
              as="form"
              width={{ base: '100%', lg: '520px', xl: '544px' }}
              onSubmit={handleSubmit}
              px={{ base: 5, md: 8, lg: 0 }}
              pt={{ base: 5, lg: 0 }}
              mx="auto"
            >
              <FormContainerAuthPages>
                <EarlyAccessHeader email={userEmail} />
                <Divider />
                <EarlyAccessForm form={form} />
                <Divider />
                <ContinueButton
                  isDisabled={!!form.formState.errors.inviteCode}
                  isLoading={form.formState.isSubmitting}
                />
                <TermsAndPrivacy buttonMessage="Continue" />
              </FormContainerAuthPages>
              <Troubleshoot troubleshootIssue="Need help?" linkDisplay={{ base: 'block', md: 'inline' }} />
            </Box>
            <FooterAuth />
          </Grid>
        </ContentContainerAuthPages>
      </MainContentAuth>
    </Box>
  );
}
